export const pattern14Data = [
  {
    id: 1,
    koreanChunks: [
      "새로운 정책이 (과거에)시행된 후,",
      "직원 생산성이",
      "증가했습니다 크게",
      "부서 전반에 걸쳐",
    ],
    englishChunks: [
      "After the new policy was implemented,",
      "employee productivity",
      "increased significantly",
      "across departments",
    ],
    fullEnglish:
      "After the new policy was implemented, employee productivity increased significantly across departments.",
    explanation:
      "접속사는 개수가 없으니 외우도록 합니다. 뒤에 절이 오니 S+V+접속사 이렇게 해석하면 됩니다. after, before",
    additionalExplanation: "",
  },
  {
    id: 2,
    koreanChunks: [
      "팀이 일했음에도 불구하고",
      "오버타임을",
      "몇주동안",
      "충족시키기 위해 고객의 기대를,",
      "프로젝트 마감일은",
      "여전히 지켜지지 않았습니다",
      "예상치 못한 지연으로 인해",
      "공급망 안에서",
    ],
    englishChunks: [
      "Although the team worked",
      "overtime",
      "for several consecutive weeks",
      "to meet the client's expectations,",
      "the project deadline",
      "was still missed",
      "due to an unexpected delay",
      "in the supply chain",
    ],
    fullEnglish:
      "Although the team worked overtime for several consecutive weeks to meet the client's expectations, the project deadline was still missed due to an unexpected delay in the supply chain.",
    explanation:
      "접속사 'Although'는 양보의 의미로 사용되었습니다. '~에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 팀의 노력(초과근무)을 나타내고, 두 번째 절은 그럼에도 불구하고 발생한 결과(마감일 미준수)를 나타냅니다.",
    additionalExplanation:
      "접속사는 개수가 없으니 외우도록 합니다. 뒤에 절이 오니 S+V+접속사 이렇게 해석하면 됩니다. although / though / even though / even if",
  },
  {
    id: 3,
    koreanChunks: [
      "그가 충족했음에도 불구하고",
      "모든 자격 요건을",
      "나열된 구인공고에",
      "그리고 받았음에도 불구하고",
      "강력한 추천서를",
      "이전 고용주로부터,",
      "그는 선발되지 않았습니다",
      "최종 라운드에 면접",
      "제한된 수의 자리 때문에",
    ],
    englishChunks: [
      "Though he met",
      "all the qualifications",
      "listed in the job description",
      "and received",
      "strong recommendations",
      "from his previous employer,",
      "he wasn't selected",
      "for the final round of interviews",
      "due to the limited number of openings",
    ],
    fullEnglish:
      "Though he met all the qualifications listed in the job description and received strong recommendations from his previous employer, he wasn't selected for the final round of interviews due to the limited number of openings.",
    explanation:
      "접속사 'Though'가 양보의 의미로 사용되었습니다. '~에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 지원자의 자격 요건 충족과 추천서를 나타내고, 두 번째 절은 그럼에도 불구하고 발생한 결과(선발되지 않음)를 나타냅니다.",
    additionalExplanation:
      "접속사는 개수가 없으니 외우도록 합니다. 뒤에 절이 오니 S+V+접속사 이렇게 해석하면 됩니다. although / though / even though / even if",
  },
  {
    id: 4,
    koreanChunks: [
      "제품이 받았음에도 불구하고",
      "압도적으로 긍정적인 리뷰를",
      "업계 전문가들로부터",
      "그리고 소개되었음에도 불구하고",
      "여러 주요 기술 잡지에,",
      "판매량은 낮게 유지되었습니다",
      "목표 시장이 발견했기 때문에",
      "가격대가 매력적이지 않다고",
    ],
    englishChunks: [
      "Even though the product received",
      "overwhelmingly positive reviews",
      "from industry experts",
      "and was featured",
      "in several leading tech magazines,",
      "sales remained low",
      "as the target market found",
      "the price point unappealing",
    ],
    fullEnglish:
      "Even though the product received overwhelmingly positive reviews from industry experts and was featured in several leading tech magazines, sales remained low as the target market found the price point unappealing.",
    explanation:
      "접속사 'Even though'가 양보의 의미로 사용되었습니다. '~에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 제품의 긍정적인 평가와 미디어 노출을 나타내고, 두 번째 절은 그럼에도 불구하고 발생한 결과(낮은 판매량)를 나타냅니다.",
    additionalExplanation:
      "접속사는 개수가 없으니 외우도록 합니다. 뒤에 절이 오니 S+V+접속사 이렇게 해석하면 됩니다. although / though / even though / even if",
  },
  {
    id: 5,
    koreanChunks: [
      "예산이 승인된다 하더라도",
      "재정 위원회에 의해",
      "다음 주 회의에서,",
      "확장은 생산 시설",
      "시작되지 않을 것입니다",
      "모든 규제 요건이 검토되고 확정될 때까지",
    ],
    englishChunks: [
      "Even if the budget is approved",
      "by the finance committee",
      "during next week's meeting,",
      "the expansion of the production facility",
      "will not begin",
      "until all regulatory requirements are reviewed and finalized",
    ],
    fullEnglish:
      "Even if the budget is approved by the finance committee during next week's meeting, the expansion of the production facility will not begin until all regulatory requirements are reviewed and finalized.",
    explanation:
      "접속사 'Even if'가 양보의 의미로 사용되었습니다. '~하더라도'라는 의미로 가정적인 상황과 그에 따른 결과를 연결할 때 사용됩니다. 첫 번째 절은 예산 승인이라는 가정적 상황을 나타내고, 두 번째 절은 그런 상황에서도 발생할 결과(확장 시작이 지연됨)를 나타냅니다.",
    additionalExplanation:
      "접속사는 개수가 없으니 외우도록 합니다. 뒤에 절이 오니 S+V+접속사 이렇게 해석하면 됩니다. although / though / even though / even if",
  },
  {
    id: 6,
    koreanChunks: ["물류 담당자로서,", "검토해 주십시오", "배송 과정을"],
    englishChunks: [
      "As you are in charge of logistics,",
      "please review",
      "the shipping process",
    ],
    fullEnglish:
      "As you are in charge of logistics, please review the shipping process.",
    explanation:
      "접속사 'As'가 이유나 원인의 의미로 사용되었습니다. '~이기 때문에'라는 의미로 어떤 행동의 이유나 근거를 제시할 때 사용됩니다. 첫 번째 절은 상대방이 물류 담당자라는 이유를 나타내고, 두 번째 절은 그에 따른 요청(배송 과정 검토)을 나타냅니다.",
  },
  {
    id: 7,
    koreanChunks: ["그는 말했다", "그가 이미 확보한 것처럼", " 계약을"],
    englishChunks: ["He spoke", "as if he had already secured", "the contract"],
    fullEnglish: "He spoke as if he had already secured the contract.",
    explanation:
      "접속사 'as if'가 가정이나 비교의 의미로 사용되었습니다. '마치 ~인 것처럼'이라는 의미로 실제가 아닌 가정적 상황을 표현할 때 사용됩니다. 첫 번째 부분은 실제 행동(말했다)을 나타내고, 두 번째 부분은 그 행동이 마치 어떤 상황인 것처럼 보이는지를 나타냅니다.",
  },
  {
    id: 8,
    koreanChunks: ["그녀는 행동했다", "그녀가 책임자였던처럼", "부서의"],
    englishChunks: [
      "She acted",
      "as though she were the head",
      "of the department",
    ],
    fullEnglish: "She acted as though she were the head of the department.",
    explanation:
      "접속사 'as though'가 가정이나 비교의 의미로 사용되었습니다. '마치 ~인 것처럼'이라는 의미로 실제가 아닌 가정적 상황을 표현할 때 사용됩니다. 첫 번째 부분은 실제 행동(행동했다)을 나타내고, 두 번째 부분은 그 행동이 마치 어떤 상황인 것처럼 보이는지를 나타냅니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "회의가 재조정되었다",
      "CEO의 비행기가 예상치 못하게 지연되었기 때문에",
      "심한 기상 조건으로 인해",
    ],
    englishChunks: [
      "The meeting was rescheduled",
      "because the CEO's flight was unexpectedly delayed",
      "due to severe weather conditions",
    ],
    fullEnglish:
      "The meeting was rescheduled because the CEO's flight was unexpectedly delayed due to severe weather conditions.",
    explanation:
      "접속사 'because'가 원인이나 이유의 의미로 사용되었습니다. '~때문에'라는 의미로 어떤 결과의 원인이나 이유를 설명할 때 사용됩니다. 첫 번째 부분은 결과(회의 재조정)를 나타내고, 두 번째 부분은 그 결과의 원인(CEO 비행기 지연)을 설명합니다.",
    additionalExplanation:
      "해석은 S+V+접속사, 이유를 설명하는 접속사 because / since / as",
  },
  {
    id: 10,
    koreanChunks: [
      "캠페인이 실패했기 때문에",
      "유치하는데 새로운 사용자들을",
      "우리는 필요합니다 새로운 전략",
    ],
    englishChunks: [
      "since the campaign failed",
      "to attract new users",
      "We need a new strategy",
    ],
    fullEnglish:
      "Since the campaign failed to attract new users, we need a new strategy.",
    explanation:
      "접속사 'since'가 원인이나 이유의 의미로 사용되었습니다. '~이기 때문에'라는 의미로 어떤 결과의 원인이나 이유를 설명할 때 사용됩니다. 첫 번째 부분은 원인(캠페인 실패)을 나타내고, 두 번째 부분은 그로 인한 결과(새로운 전략의 필요성)를 설명합니다.",
    additionalExplanation:
      "접속사해석 방법은 S + V +접속사 입니다 접속사 개수가 전치사보다 더 적으니 암기하도록 합니다.  이유를 설명하는 접속사 because / since / as.",
  },
  {
    id: 11,
    koreanChunks: [
      "당신이 가지고 있으므로 ",
      "경험을",
      "협상에 있어서",
      "처리해 주세요",
      "고객을 직접",
    ],
    englishChunks: [
      "As you have",
      "experience",
      "in negotiation,",
      "please handle",
      "the client directly",
    ],
    fullEnglish:
      "As you have experience in negotiation, please handle the client directly.",
    explanation:
      "접속사 'As'가 이유나 원인의 의미로 사용되었습니다. '~이므로, ~때문에'라는 의미로 어떤 행동이나 요청의 이유를 설명할 때 사용됩니다. 첫 번째 부분은 이유(협상 경험이 있음)를 나타내고, 두 번째 부분은 그 이유로 인한 요청(고객을 직접 처리)을 설명합니다.",
    additionalExplanation:
      "접속사해석 방법은 S + V +접속사 입니다 접속사 개수가 전치사보다 더 적으니 암기하도록 합니다.  이유를 설명하는 접속사 because / since / as.",
  },
  {
    id: 12,
    koreanChunks: [
      "새로운 정책이 시행되기 전에,",
      "직원들은 필요할 것입니다",
      "참석하는 것이",
      "의무적인 교육 세션에",
    ],
    englishChunks: [
      "Before the new policy takes effect,",
      "employees will be required",
      "to attend",
      "a mandatory training session",
    ],
    fullEnglish:
      "Before the new policy takes effect, employees will be required to attend a mandatory training session.",
  },
  {
    id: 13,
    koreanChunks: ["최종 디자인이 승인되면,", "생산이 시작될 것입니다", "즉시"],
    englishChunks: [
      "Once the final design is approved,",
      "production will commence",
      "immediately",
    ],
    fullEnglish:
      "Once the final design is approved, production will commence immediately.",
    explanation:
      "접속사 'Once'가 시간적 조건을 나타내는 의미로 사용되었습니다. '일단 ~하면'이라는 의미로 한 사건이 발생한 후에 다른 사건이 뒤따라 일어남을 표현할 때 사용됩니다. 첫 번째 부분은 조건(디자인 승인)을 나타내고, 두 번째 부분은 그 조건이 충족된 후에 일어날 일(생산 시작)을 설명합니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "직원들은 접근할 수 없습니다",
      "서버실에",
      "직원들이 적절한 권한이 없다면",
    ],
    englishChunks: [
      "Employees are not allowed to access",
      "the server room",
      "unless they have proper authorization",
    ],
    fullEnglish:
      "Employees are not allowed to access the server room unless they have proper authorization.",
    explanation:
      "접속사 'unless'가 조건의 의미로 사용되었습니다. 'unless'는 '~하지 않으면', '~이 아니라면'이라는 의미로 부정적인 조건을 나타낼 때 사용됩니다. 이 문장에서는 서버실 접근이 허용되지 않는 조건(적절한 권한이 없는 경우)을 설명합니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "확인해주세요 당신의 참석을",
      "월요일까지",
      "우리가 확정할 수 있도록",
      "좌석 배치를",
      "행사를 위한",
    ],
    englishChunks: [
      "Please confirm your attendance",
      "by Monday",
      "so that we can finalize",
      "the seating arrangements",
      "for the event",
    ],
    fullEnglish:
      "Please confirm your attendance by Monday so that we can finalize the seating arrangements for the event.",
    explanation:
      "접속사 'so that'이 목적이나 의도를 나타내는 의미로 사용되었습니다. 'so that'은 '~하기 위해서'라는 의미로 어떤 행동의 목적이나 의도를 설명할 때 사용됩니다. 이 문장에서는 참석 여부를 알려달라는 요청의 목적(좌석 배치 확정)을 설명합니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "남아주세요",
      "대기실에서",
      "당신의 이름이 불릴 때까지",
      "접수원에 의해",
    ],
    englishChunks: [
      "Please remain",
      "in the waiting area",
      "until your name is called",
      "by the receptionist",
    ],
    fullEnglish:
      "Please remain in the waiting area until your name is called by the receptionist.",
  },
  {
    id: 17,
    koreanChunks: ["계약서가 서명되면", "결제가 처리될 것입니다"],
    englishChunks: [
      "When the contract is signed",
      "the payment will be processed",
    ],
    fullEnglish: "When the contract is signed, the payment will be processed.",
    explanation:
      "접속사 'when'이 시간적 조건을 나타내는 의미로 사용되었습니다. 'when'은 '~할 때'라는 의미로 어떤 사건이 발생하는 시점을 나타낼 때 사용됩니다. 이 문장에서는 결제가 처리되는 시점(계약서가 서명되는 때)을 설명합니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "대부분의 지원자들이 가졌지만",
      "강력한 이력서를",
      "몇 명만이 불려갔습니다",
      "면접을 위해",
    ],
    englishChunks: [
      "While most applicants had strong résumés",
      "only a few were called",
      "for interviews",
    ],
    fullEnglish:
      "While most applicants had strong résumés, only a few were called for interviews.",
    explanation:
      "접속사 'While'이 대조나 양보의 의미로 사용되었습니다. 'While'은 '~하는 동안' 또는 '~이지만'이라는 의미로 두 상황 간의 대조를 나타낼 때 사용됩니다. 이 문장에서는 강한 이력서를 가진 많은 지원자들과 실제로 면접에 불려간 소수의 지원자 사이의 대조를 보여줍니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "직원들은 접속할 수 있습니다",
      "데이터베이스에",
      "그들이 가지는 곳 어디서든",
      "인터넷 연결을",
    ],
    englishChunks: [
      "Employees can access",
      "the database",
      "wherever they have",
      "an internet connection",
    ],
    fullEnglish:
      "Employees can access the database wherever they have an internet connection.",
    explanation:
      "접속사 'wherever'가 장소에 관한 조건을 나타내는 의미로 사용되었습니다. 'wherever'는 '어디서든지'라는 의미로 장소에 상관없이 어떤 조건이 적용됨을 나타낼 때 사용됩니다. 이 문장에서는 직원들이 인터넷 연결이 있는 모든 장소에서 데이터베이스에 접속할 수 있음을 설명합니다.",
  },

  {
    id: 20,
    koreanChunks: [
      "남아있습니다 불분명한 상태로",
      "고객이 갱신할지",
      "연간 계약을",
    ],
    englishChunks: [
      "It remains unclear",
      "whether the client will renew",
      "the annual agreement",
    ],
    fullEnglish:
      "It remains unclear whether the client will renew the annual agreement.",
    explanation:
      "접속사 'whether'가 불확실성이나 가능성을 나타내는 의미로 사용되었습니다. 'whether'는 '~인지 아닌지'라는 의미로 두 가지 가능성 중 하나를 나타낼 때 사용됩니다. 이 문장에서는 고객이 연간 계약을 갱신할지 여부가 불확실함을 표현합니다.",
  },

  {
    id: 21,
    koreanChunks: [
      "매니저가 참석하거나",
      "미팅에",
      "비서가 갈 것입니다",
      "그녀를 대신해서",
    ],
    englishChunks: [
      "Either the manager will attend",
      "the meeting",
      "or the assistant will go",
      " in her place",
    ],
    fullEnglish:
      "Either the manager will attend the meeting, or the assistant will go in her place.",
    explanation:
      "접속사 'Either...or'가 두 가지 선택지 중 하나를 나타내는 의미로 사용되었습니다. 'Either...or'는 '~이거나 ~이거나'라는 의미로 두 가지 가능성 중 하나가 발생할 것임을 나타낼 때 사용됩니다. 이 문장에서는 매니저가 회의에 참석하거나 비서가 대신 참석할 것이라는 두 가지 가능성을 표현합니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "공급업체도 응답하지 않았고,",
      "우리 요청에",
      "운송 회사도 제공하지 않았습니다.",
      " 업데이트를 ",
    ],
    englishChunks: [
      "Neither the supplier responded",
      "to our request,",
      "nor did the shipping company provide",
      "an update.",
    ],
    fullEnglish:
      "Neither the supplier responded to our request, nor did the shipping company provide an update.",
    explanation:
      "접속사 'Neither...nor'가 두 가지 부정적인 상황을 연결하는 의미로 사용되었습니다. 'Neither...nor'는 '~도 아니고 ~도 아니다'라는 의미로 두 가지 상황이 모두 부정적임을 강조할 때 사용됩니다. 이 문장에서는 공급업체와 운송 회사 모두 기대되는 행동을 하지 않았음을 표현합니다.",
  },
  {
    id: 23,
    koreanChunks: [
      "매출 수치가 증가했습니다,",
      "그리고 고객 만족도도 향상되었습니다.",
      "크게",
    ],
    englishChunks: [
      "Both the sales figures increased,",
      "and customer satisfaction improved",
      "significantly.",
    ],
    fullEnglish:
      "Both the sales figures increased, and customer satisfaction improved significantly.",
    explanation:
      "접속사 'Both...and'가 두 가지 긍정적인 상황을 연결하는 의미로 사용되었습니다. 'Both...and'는 '~도 ~도'라는 의미로 두 가지 상황이 모두 발생했음을 강조할 때 사용됩니다. 이 문장에서는 매출 수치가 증가했고 동시에 고객 만족도도 향상되었다는 두 가지 긍정적인 결과를 표현합니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "그녀는 완료했을 뿐만 아니라",
      "프로젝트를",
      "일정보다 앞서,",
      "그녀는 또한 줄였습니다",
      "전체 비용을",
    ],
    englishChunks: [
      "Not only did she complete",
      "the project",
      "ahead of schedule,",
      "but she also reduced",
      "the overall cost.",
    ],
    fullEnglish:
      "Not only did she complete the project ahead of schedule, but she also reduced the overall cost.",
    explanation:
      "접속사 'Not only...but also'가 두 가지 긍정적인 상황을 강조하는 의미로 사용되었습니다. 'Not only...but also'는 '~뿐만 아니라 ~도'라는 의미로 두 가지 상황이 모두 발생했으며 특히 첫 번째 상황에 추가하여 두 번째 상황도 발생했음을 강조할 때 사용됩니다. 이 문장에서는 그녀가 일정보다 빨리 프로젝트를 완료했고, 게다가 비용까지 절감했다는 두 가지 성과를 강조합니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "우리는 결정해야 합니다",
      "우리가 진행할것인지",
      "프로젝트를",
      "또는 연기할지를 프로젝트를",
      "다음 분기까지",
    ],
    englishChunks: [
      "We need to decide",
      "whether we will proceed",
      "with the project",
      "or postpone it",
      "until next quarter.",
    ],
    fullEnglish:
      "We need to decide whether we will proceed with the project or postpone it until next quarter.",
    explanation:
      "접속사 'whether...or'가 두 가지 선택지를 제시하는 의미로 사용되었습니다. 'whether...or'는 '~인지 아니면 ~인지'라는 의미로 두 가지 가능성 중 하나를 선택해야 하는 상황을 표현할 때 사용됩니다. 이 문장에서는 프로젝트를 지금 진행할지 아니면 다음 분기로 연기할지에 대한 결정이 필요함을 나타냅니다.",
  },
  {
    id: 26,
    koreanChunks: [
      "최종 초안이 승인이 되자마자,",
      "마케팅 팀은 시작할 것입니다",
      "준비하는것을 홍보 자료를",
    ],
    englishChunks: [
      "As soon as the final draft is approved,",
      "the marketing team will begin",
      "preparing the promotional materials.",
    ],
    fullEnglish:
      "As soon as the final draft is approved, the marketing team will begin preparing the promotional materials.",
    explanation:
      "접속사 'As soon as'가 시간적 순서를 나타내는 의미로 사용되었습니다. 'As soon as'는 '~하자마자'라는 의미로 한 사건이 발생한 직후에 다른 사건이 뒤따라 일어남을 표현할 때 사용됩니다. 이 문장에서는 최종 초안이 승인되는 즉시 마케팅 팀이 홍보 자료 준비를 시작할 것임을 나타냅니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "매니저가 돌아올 즈음에",
      "회의에서",
      "분기 보고서가 준비되어 있어야 합니다",
      "검토를 위해서",
    ],
    englishChunks: [
      "By the time the manager returns",
      "from the conference,",
      "the quarterly report should be ready",
      "for review.",
    ],
    fullEnglish:
      "By the time the manager returns from the conference, the quarterly report should be ready for review.",
    explanation:
      "접속사 'By the time'이 시간적 관계를 나타내는 의미로 사용되었습니다. 'By the time'은 '~할 때쯤에는'이라는 의미로, 한 사건이 발생하는 시점까지 다른 사건이 완료될 것임을 표현할 때 사용됩니다. 이 문장에서는 매니저가 회의에서 돌아오는 시점까지 분기 보고서가 검토할 준비가 되어 있어야 함을 나타냅니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "이제 새 시스템이 완전히 가동되었기 때문에",
      "우리는 기대합니다",
      "더 적은 지연을",
      "처리하는데 있어서 고객 요구를",
    ],
    englishChunks: [
      "Now that the new system is fully operational,",
      "we expect",
      "fewer delays",
      "in processing customer requests.",
    ],
    fullEnglish:
      "Now that the new system is fully operational, we expect fewer delays in processing customer requests.",
    explanation:
      "접속사 'Now that'이 원인과 결과의 관계를 나타내는 의미로 사용되었습니다. 'Now that'은 '이제 ~하기 때문에'라는 의미로, 현재 상황이 특정 결과나 기대를 가져오는 원인임을 표현할 때 사용됩니다. 이 문장에서는 새 시스템이 완전히 가동된 것이 고객 요청 처리 지연이 줄어들 것이라는 기대의 원인임을 나타냅니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "새 정책은 더 효과적입니다",
      "이전 정책보다",
      "새 정책은 제공한다는 점에서",
      "더 명확한 지침을",
      "재택근무에 대한",
    ],
    englishChunks: [
      "The new policy is more effective",
      "than the previous one,",
      "in that it provides",
      "clearer guidelines",
      "for remote work.",
    ],
    fullEnglish:
      "The new policy is more effective than the previous one, in that it provides clearer guidelines for remote work.",
    explanation:
      "접속사 'in that'이 이유나 방식을 설명하는 의미로 사용되었습니다. 'in that'은 '~라는 점에서'라는 의미로, 앞서 언급된 내용에 대한 구체적인 이유나 방식을 설명할 때 사용됩니다. 이 문장에서는 새 정책이 더 효과적인 이유가 재택근무에 대한 더 명확한 지침을 제공한다는 점임을 나타냅니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "직원들은 재택근무를 할 수 있습니다",
      "일주일에 이틀",
      "그들이 맞춘다는조건으로",
      "모든 주간 마감일을",
    ],
    englishChunks: [
      "Employees may work from home",
      "two days a week,",
      "provided that they meet",
      "all weekly deadlines.",
    ],
    fullEnglish:
      "Employees may work from home two days a week, provided that they meet all weekly deadlines.",
    explanation:
      "접속사 'provided that'이 조건을 나타내는 의미로 사용되었습니다. 'provided that'은 '~한다는 조건으로'라는 의미로, 어떤 일이 발생하기 위한 필요 조건을 표현할 때 사용됩니다. 이 문장에서는 직원들이 일주일에 이틀 재택근무를 할 수 있는 조건이 모든 주간 마감일을 맞추는 것임을 나타냅니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "보관하세요 인쇄본을",
      "여행 일정표의",
      "휴대폰 배터리가 방전될 경우를 대비하여",
      "여행 중에",
    ],
    englishChunks: [
      "Please keep a printed copy",
      "of the itinerary",
      "in case your phone battery runs out",
      "during travel.",
    ],
    fullEnglish:
      "Please keep a printed copy of the itinerary in case your phone battery runs out during travel.",
    explanation:
      "접속사 'in case'가 가능성이나 예방책을 나타내는 의미로 사용되었습니다. 'in case'는 '~할 경우를 대비하여'라는 의미로, 미래에 발생할 수 있는 상황에 대비하기 위한 행동을 설명할 때 사용됩니다. 이 문장에서는 여행 중 휴대폰 배터리가 방전될 가능성에 대비하여 여행 일정표의 인쇄본을 보관하라고 조언하고 있습니다.",
  },
  {
    id: 32,
    koreanChunks: [
      "당신을사용할 수 있습니다 회의실을 ",
      "다른 부서에서 예약하지 않은 경우에 한해",
    ],
    englishChunks: [
      "You may use the meeting room",
      "as long as no other department has it reserved.",
    ],
    fullEnglish:
      "You may use the meeting room as long as no other department has it reserved.",
    explanation:
      "접속사 'as long as'가 조건을 나타내는 의미로 사용되었습니다. 'as long as'는 '~하는 한, ~인 경우에 한해'라는 의미로, 어떤 일이 가능하거나 허용되는 조건을 표현할 때 사용됩니다. 이 문장에서는 회의실을 사용할 수 있는 조건이 다른 부서에서 예약하지 않은 경우임을 나타냅니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "공급업체가 인상했음에도",
      "가격을",
      "우리는 결정했습니다 유지하기로 계약을",
      "그들의 꾸준한 서비스 품질 때문에",
    ],
    englishChunks: [
      "Even though the supplier raised",
      "their prices,",
      "we decided to continue the contract",
      "due to their consistent service quality.",
    ],
    fullEnglish:
      "Even though the supplier raised their prices, we decided to continue the contract due to their consistent service quality.",
    explanation:
      "접속사 'even though'가 양보의 의미로 사용되었습니다. 'even though'는 '~에도 불구하고'라는 의미로, 예상과 다른 결과가 발생했을 때 사용됩니다. 이 문장에서는 공급업체가 가격을 인상했음에도 불구하고 계약을 유지하기로 결정했다는 것을 나타내며, 그 이유는 꾸준한 서비스 품질 때문입니다.",
  },
  {
    id: 34,
    koreanChunks: [
      "마케팅팀은 선호합니다",
      "대면 회의를,",
      "IT 부서는 수행하는 반면에",
      "대부분 소통을 온라인으로",
    ],
    englishChunks: [
      "The marketing team prefers",
      "face-to-face meetings,",
      "whereas the IT department conducts",
      "most of its communication online.",
    ],
    fullEnglish:
      "The marketing team prefers face-to-face meetings, whereas the IT department conducts most of its communication online.",
    explanation:
      "접속사 'whereas'가 대조의 의미로 사용되었습니다. 'whereas'는 '~인 반면에'라는 의미로, 두 가지 상반되거나 대조되는 상황을 비교할 때 사용됩니다. 이 문장에서는 마케팅팀이 대면 회의를 선호하는 것과 IT 부서가 대부분 온라인으로 소통하는 것을 대조하고 있습니다.",
  },
];
